import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Col, Input, Form, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {update } from "../Features/userSlice";
import axiosInstance from "../axiosInstance";
import { constants } from "../Utils/constants";

const ProfileEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {currentUser} = useSelector(state=>state.user)

  const [userDetails, setUserDetails] = useState({
    firstName: currentUser.firstName,
    lastName: currentUser.lastName,
    email: currentUser.email,
    mobile: currentUser.mobile,
    password: "",
    gender: currentUser.gender,
  });
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleChange = (e) => {
    setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
  };

  const handleSubmit =async (e) => {
    if (userDetails.firstName.trim() === "") {
      toast.error("First name cannot be empty !!!", { theme: "colored" });
    } else if (userDetails.lastName.trim() === "") {
      toast.error("Last name cannot be empty !!!", { theme: "colored" });
    } else if (userDetails.email.trim() === "") {
      toast.error("Email field cannot be empty !!!", { theme: "colored" });
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
        userDetails.email
      )
    ) {
      toast.error("Email address is not valid !!!", {
        theme: "colored",
      });
    } else if (userDetails.mobile.trim() === "") {
      toast.error("Mobile field cannot be empty !!!", { theme: "colored" });
    } else if (!/^\d{10}$/.test(userDetails.mobile)) {
      toast.error("Mobile No. is not valid !!!", { theme: "colored" });
    } else if (userDetails.password.trim() === "") {
      toast.error("Paasword field cannot be empty !!!", { theme: "colored" });
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        userDetails.password
      )
    ) {
      toast.error("Paasword is not strong enough !!!", {
        theme: "colored",
      });
    } else if (confirmPassword.trim() === "") {
      toast.error("Enter confirm password field !!!", {
        theme: "colored",
      });
    } else if (userDetails.password !== confirmPassword) {
      toast.error("Password did not matched properly !!!", {
        theme: "colored",
      });
    } else if (userDetails.gender.trim() === "") {
      toast.error("Gender field is not selected !!!", { theme: "colored" });
    } else {
      try {
        const resp = await axiosInstance.post(constants.serverUrl+"/user/update", {...userDetails,id:currentUser.id});
        
        if(resp.data?.status==false){
          toast.success(resp.data?.message);
        }else{
          //navigate("/home");

          dispatch(update(userDetails));
          toast.success("info updated Successfull !!!");
        }
      } catch (err) {
        
      }
      
    }
  };

  return (
    <Col lg="7" md="7">
      <Form method="post">
        <h4 className="fw-bold mb-4">Profile Settings</h4>
        <FormGroup className="contact__form">
          <Input
            placeholder="First Name"
            name="firstName"
            type="text"
            value={userDetails.firstName}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup className="contact__form">
          <Input
            placeholder="Last Name"
            name="lastName"
            type="text"
            value={userDetails.lastName}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup className="contact__form">
          <Input
            placeholder="Enter Email ID"
            type="text"
            name="email"
            value={userDetails.email}
            disabled
            onChange={handleChange}
            style={{ cursor:"not-allowed"}}
          />
        </FormGroup>
        <FormGroup className="contact__form">
          <Input
            placeholder="Enter Mobile"
            type="text"
            name="mobile"
            value={userDetails.mobile}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup className="contact__form">
          <Input
            placeholder="Enter Password"
            type="password"
            name="password"
            
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup className="contact__form">
          <Input
            placeholder="Confirm Password"
            type="password"
            name="confirmPassword"
            onChange={(e) => {
              setConfirmPassword(e.target.value);
            }}
          />
        </FormGroup>
        <FormGroup className="mx-1">
          <Label>Select Gender:</Label>
          <Input
            className="mx-2"
            floating
            type="radio"
            id="male"
            name="gender"
            label="Male"
            value="M"
            checked={userDetails.gender === 'M'}
            onChange={handleChange}
          />
          <Label className="mx-1">Male</Label>
          <Input
            floating
            className="mx-2"
            type="radio"
            id="female"
            name="gender"
            label="Female"
            value="F"
            checked={userDetails.gender === 'F'}
            onChange={handleChange}
          />
          <Label className="mx-1">Female</Label>
        </FormGroup>
      </Form>
      <div className="mt-5 text-center">
        <button className="contact__btn" type="button" onClick={handleSubmit}>
          Save Profile
        </button>
      </div>
    </Col>
  );
};

export default ProfileEdit;
